import { Link, useNavigate } from 'react-router-dom';
import { CustomerForm } from './CustomerForm';
import { useCreateCustomer } from './hooks';
import { usePageTitle } from '../../hooks/usePageTitle';
import { toCustomerPayload, type CustomerFormValues } from './customerSchema';

export function CustomerNewPage() {
  usePageTitle('New client');
  const nav = useNavigate();
  const create = useCreateCustomer();

  const onSubmit = async (values: CustomerFormValues) => {
    const created = await create.mutateAsync(toCustomerPayload(values));
    nav(`/customers/${created.id}`);
  };

  return (
    <div className="max-w-3xl mx-auto px-4 py-8 space-y-6">
      <div>
        <Link to="/customers" className="text-sm text-slate-500 hover:text-pine">
          ← Clients
        </Link>
        <h1 className="font-display text-2xl font-semibold text-ink mt-2">New Client</h1>
      </div>

      <CustomerForm
        submitLabel="Create client"
        onSubmit={onSubmit}
        onCancel={() => nav('/customers')}
        submitting={create.isPending}
      />
      {create.isError && (
        <p className="text-sm text-danger">Save failed — please check your inputs and try again.</p>
      )}
    </div>
  );
}
